<template>
    <el-dialog
        :title="'打印模板选择'"
        :width="'900px'"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="true"
        :before-close="beforeClose"
        :custom-class="'dispatchNewPrintDialog'"
        top="5vh"
    >
        <div class="print-wrapper" v-if="printListLength">
            <el-row>
                <el-col :span="8" v-for="(item, index) in printList" :key="index" class="container">
                    <p class="title">{{ dictData.PRINT_TEMPLATE_STYLE_ATTRIBUTE[item.templateClassification] }}</p>
                    <el-scrollbar class="scrollbar">
                        <div class="templateList">
                            <el-checkbox-group v-model="item.checkedTemplate">
                                <el-checkbox
                                    v-for="templateItem in item.templateList"
                                    :key="templateItem.templateCode"
                                    :label="templateItem.templateCode"
                                    class="checkbox-item"
                                >
                                {{ templateItem.templateName }}
                                <p
                                    @click.stop.prevent="handlePreview(templateItem)"
                                    class="preview-text"> 预览</p>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-scrollbar>
                </el-col>
            </el-row>
        </div>
        <div class="text-container" v-else>
            <p>提示：当前发车单没有匹配的打印模板，请跳转到老版打印界面进行打印或联系城配IT产品经理进行配置。</p>
        </div>
        <div class="new-printf-tip">
            <i class="el-icon-warning tip-icon"></i>
            {{ dictData.NEW_PRINTF_TIP_TEXT.data }}
            <span @click="jumpToUrl" v-if="urlShow">{{ dictData.NEW_PRINTF_TIP_URL.data }}</span>
        </div>
        <div slot="footer" class="print-dialog-footer">
            <el-row :gutter="20">
                <el-col :span="8" style="text-align: left;">
                    <el-checkbox v-model="isRemember" class="checkbox">记住我的选择</el-checkbox>
                    <el-button type="primary" @click="openOldPrintDialog" class="back-to" v-if="!batchPrint">跳转到老版打印界面</el-button>
                </el-col>
                <el-col :span="8">
                    <div class="printf-input-customer" v-if="!isWaybillManage && !batchPrint">
                        <p>以客户订单号打印</p>
                        <el-input placeholder="多个客户订单号，以逗号或空格隔开" v-model="customerOrderNo" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="8" :offset="!isWaybillManage && !batchPrint ? 0 : 8">
                    <el-button @click="beforeClose">取 消</el-button>
                    <el-button type="primary" @click="openPrintLog" v-if="!batchPrint">打印日志</el-button>
                    <el-button type="primary" @click="printBtn" :disabled="!printListLength" :loading="btnLoading">打 印</el-button>
                </el-col>
            </el-row>
        </div>

        <dispatch-print-log
            v-if="isShowPrintLogDialog"
            ref="dispatchPrintLog"
            :isShowPrintLogDialog.sync="isShowPrintLogDialog"
            :componentsData="componentsData[0]"
        ></dispatch-print-log>

        <dispatch-repeat-print
            v-if="isShowPrintReasonDialog"
            ref="dispatchRepeatPrint"
            :isShowPrintReasonDialog.sync="isShowPrintReasonDialog"
            :componentsData="componentsData"
            :tooltip="tooltip"
            @handlePrint="handlePrint"
        ></dispatch-repeat-print>

        <dispatch-print-preview
            v-if="isShowPrintPreviewDialog"
            ref="dispatchPrintPreview"
            :isShowPrintPreviewDialog.sync="isShowPrintPreviewDialog"
            :currentPrintData="currentPrintData"
        ></dispatch-print-preview>
    </el-dialog>
</template>

<script>
import { searchFieldSeperated } from '@/modules/transport/otp/views/distributeManage/dispatchMgmt/searcher.js';
import { getLocalStorage, setLocalStorage, handleBatchDispatchPrint, checkedDataValidated } from './util.js';
import { batchCheckPrintCount } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';
import bigDataLog from '@/utils/bigDataLog';
import _ from 'lodash';
export default {
    name: 'DispatchNewPrintDialog',
    components: {
        DispatchPrintLog: () => import('../dispatchPrintLog/Index.vue'),
        DispatchRepeatPrint: () => import('../dispatchRepeatPrint/Index.vue'),
        DispatchPrintPreview: () => import('../dispatchPrintPreview/Index.vue')
    },
    props: {
        componentsData: {
            type: Array,
            default () {
                return [];
            }
        },
        printConfig: {
            type: Array,
            default () {
                return [];
            }
        },
        isWaybillManage: {
            type: Boolean,
            default () {
                return false;
            }
        },
        batchPrint: {
            type: Boolean,
            default () {
                return false;
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        },
        professionalCompanyConfig: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            printList: [],
            customerOrderNo: '',
            isCheckAll: false,
            isRemember: true,
            visible: false,
            btnLoading: false,
            timeOutFlag: false,
            isIndeterminate: false,
            isShowPrintLogDialog: false,
            isShowPrintReasonDialog: false,
            isShowPrintPreviewDialog: false,
            checkedTemplateList: [],
            isCloseDialog: false, // 打印后是否关闭弹窗，批量打印后关闭，预览不关闭
            tooltip: '',
            CPLimit: false,
            LDLimit: false,
            currentPrintData: {}
        };
    },
    computed: {
        printListLength () {
            return this.printList.length;
        },
        urlShow () {
            return this.dictData.NEW_PRINTF_TIP_URL && this.dictData.NEW_PRINTF_TIP_URL.data;
        }
    },
    async mounted () {
        await this.getRememberFlag();
        this.printList = _.cloneDeep(this.printConfig);
        this.initRadioStatus();
        this.CPLimit = this.professionalCompanyConfig.printCompanyConfig || false;
        this.LDLimit = this.professionalCompanyConfig.printLclConfig || false;
        this.visible = true;
    },
    methods: {
        // 从缓存中读取 记住我的选择 状态
        getRememberFlag () {
            this.isRemember = getLocalStorage('isRemember');
        },
        initRadioStatus () {
            if (!this.printList.length) return;
            this.printList.forEach(item => this.$set(item, 'checkedTemplate', []));
            if (this.isRemember) {
                const storagePrintTemplate = getLocalStorage('printTemplate');
                const allCheckedTemplate = [];
                this.printList.forEach(currentPrintType => {
                    const storagePrintType = storagePrintTemplate.find(storageItem => storageItem.styleAttributeCode === currentPrintType.templateClassification);
                    if (storagePrintType) {
                        const storagePrintTemplate = currentPrintType.templateList.filter(templateItem => storagePrintType.checkedTemplate.includes(templateItem.templateCode));
                        if (storagePrintTemplate.length) {
                            currentPrintType.checkedTemplate = storagePrintTemplate.map(v => v.templateCode);
                            allCheckedTemplate.push(...currentPrintType.checkedTemplate);
                        }
                    }
                });
                if (!allCheckedTemplate.length) {
                    this.printList[0].checkedTemplate = [this.printList[0].templateList[0].templateCode];
                }
            } else {
                this.printList[0].checkedTemplate = [this.printList[0].templateList[0].templateCode];
            }
        },
        // 跳转到老版打印界面
        openOldPrintDialog () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-jump-old-print');
            this.$emit('openOldPrintDialog', this.componentsData[0]);
        },
        jumpToUrl () {
            window.open(this.dictData.NEW_PRINTF_TIP_URL.data);
        },
        // 预览
        handlePreview (templateItem) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-print-preview');
            this.currentPrintData = {
                dispatchNoList: [...new Set(this.componentsData.map(v => v.dispatchNo))],
                templateName: templateItem.templateName,
                templateCode: templateItem.templateCode
            };
            this.isShowPrintPreviewDialog = true;
        },
        // 批量打印
        printBtn () {
            const isValidated = checkedDataValidated(this.printList);
            if (!isValidated) return;
            const checkedTemplate = this.printList.filter(v => v.checkedTemplate && v.checkedTemplate.length).map(v => v.checkedTemplate);
            this.checkedTemplateList = [...new Set(checkedTemplate.flat())];
            if (this.checkedTemplateList.length > 5) {
                return this.$message.warning('最多选择5个模板进行批量打印');
            }
            this.isCloseDialog = true;
            this.checkPrint();
        },
        // 打印校验
        checkPrint () {
            batchCheckPrintCount({
                dispatchNoList: [...new Set(this.componentsData.map(v => v.dispatchNo))],
                templateCodeList: this.checkedTemplateList
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        if (res.data) {
                            this.handlePrint();
                        } else if (this.validateProfessionalCompany()) {
                            this.isShowPrintReasonDialog = true;
                        } else {
                            this.handlePrint();
                        }
                    } else {
                        this.handlePrint();
                    }
                }).catch(() => {});
        },
        // 专司卡控
        validateProfessionalCompany () {
            const professionalCompanyList = this.isWaybillManage
                ? this.componentsData.map(v => v.dispatchProfessionCompany).filter(Boolean)
                : this.componentsData.map(v => v.professionalCompany).filter(Boolean);
            this.tooltip = '';
            if (this.CPLimit && this.LDLimit) {
                // 城配开启，零担开启，含有城配/零担都需要备注（城配、零担、城配+其他、零担+其他、城配+零担）
                return professionalCompanyList.some(professionalCompany => professionalCompany.includes('城配') || professionalCompany.includes('零担'));
            } else if (this.CPLimit && !this.LDLimit) {
                // 城配开启，零担关闭，含有城配都需要备注（城配、城配+零担、城配+其他）
                if (professionalCompanyList.some(professionalCompany => professionalCompany.includes('城配')) &&
                    professionalCompanyList.some(professionalCompany => professionalCompany.includes('零担'))) {
                    this.tooltip = '因城配送装专司对单据补打管控，本发车单含有城配单据，请您选择补打原因';
                }
                return professionalCompanyList.some(professionalCompany => professionalCompany.includes('城配'));
            } else if (!this.CPLimit && this.LDLimit) {
                // 城配关闭，零担开启，含有零担都需要备注（零担、零担+其他、城配+零担）
                if (professionalCompanyList.some(professionalCompany => professionalCompany.includes('城配')) &&
                    professionalCompanyList.some(professionalCompany =>professionalCompany.includes('零担'))) {
                    this.tooltip = '因基地干线专司对单据补打管控，本发车单含有基地单据，请您选择补打原因';
                }
                return professionalCompanyList.some(professionalCompany => professionalCompany.includes('零担'));
            } else {
                // 城配关闭，零担关闭，所有专司都不需要备注
                return false;
            }
        },
        handlePrint (data, repeatPrintReason) {
            this.handleStorage();
            const params = {
                templateCodeList: this.checkedTemplateList,
                dispatchNoList: [...new Set(this.componentsData.map(v => v.dispatchNo))],
                customerOrderNoList: searchFieldSeperated(this.customerOrderNo || '')
            };
            if (repeatPrintReason && Object.keys(repeatPrintReason).length) {
                params.reason = repeatPrintReason.reason || '';
                params.remark = repeatPrintReason.remark || '';
            }
            // 处理打印逻辑
            handleBatchDispatchPrint(this, params, this.isCloseDialog);
        },
        // 缓存逻辑处理
        handleStorage () {
            setLocalStorage('isRemember', this.isRemember);
            if (!this.isRemember) return;
            const storagePrintObject = this.printList.filter(v => v.checkedTemplate && v.checkedTemplate.length).map((item) => {
                return {
                    styleAttributeCode: item.templateClassification,
                    checkedTemplate: item.checkedTemplate
                };
            });
            setLocalStorage('printTemplate', storagePrintObject);
        },
        openPrintLog () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-print-log');
            this.isShowPrintLogDialog = true;
        },
        beforeClose () {
            this.$emit('update:isShowNewPrintDialog', false);
        }
    }
};
</script>

<style lang="less">
.dispatchNewPrintDialog {
    .text-container {
        // text-align: center;
        font-size: 13px;
        color: red;
    }
    .new-printf-tip {
        padding: 8px 15px 3px;
        border-radius: 5px;
        line-height: 25px;
        background-color: #EBEEF5;
        justify-content: center;
        .tip-icon {
            margin-right: 10px;
            font-size: 15px;
            color: #00BCBF;
        }
        span {
            cursor: pointer;
            text-decoration: underline;
        }
    }
    .title {
        display: inline-block;
        // color: #00BCBF;
        // border-bottom: 1px solid #EBEEF5;
        font-size: 14px;
        margin: 0px 0px 5px 5px;
        padding-bottom: 2px;
        // padding: 0px 5px 3px 5px;
    }
    .container {
        padding-right: 10px;
    }
    .templateList{
        padding-left: 5px;
    }
    .scrollbar{
        height: 120px;
        margin-bottom: 20px;
    }
    .is-horizontal {
        display: block;
    }
    /* 不展示水平滚动条 */
    /deep/ .is-horizontal {
        display: none;
    }
    .el-checkbox-group {
        width: 100%;
    }
    .el-checkbox__label{
        line-height: 24px;
        font-size: 12px;
    }
    .checkbox-item {
        display: block;
        line-height: 24px;
        .preview-text{
            display: inline-block;
            // color: rgb(255, 199, 0);
            font-weight: 900;
            margin: 0px 0px 0px 6px;
        }
    }
    .radio-item .el-radio__inner {
        border-radius: 0px;
    }
    // 单选按钮实现对勾样式
    .radio-item .el-radio__input.is-checked .el-radio__inner::after {
        content: '';
        width: 8px;
        height: 3px;
        border: 2px solid white;
        border-top: transparent;
        border-right: transparent;
        text-align: center;
        display: block;
        position: absolute;
        top: 2px;
        left: 1px;
        transform: rotate(-45deg);
        border-radius: 0px;
        background: none;
    }
    .el-dialog__body {
        min-height: 100px;
        max-height: 70vh;
        overflow: auto;
    }
    .print-dialog-footer {
        .el-row {
            line-height: 40px;
        }
        .checkbox {
            margin-right: 12px;
        }
        .printf-input-customer {
            p {
                display: inline-block;
                font-size: 12px;
                margin: 0 10px 0 0;
            }
            .el-input {
                width: 160px;
            }
        }
    }
}
</style>
